import { createRoot } from 'react-dom/client';
import { ConfirmModal } from './ConfirmModal';

const confirmId = 'confirm-container';
export function ConfirmBeforeSubmit(
    event: SubmitEvent,
    texts:
        | { title: string; body: string; cancel: string; confirm: string }
        | { title: string; bodyHTML: string; cancel: string; confirm: string },
) {
    event.preventDefault();

    let elm = document.getElementById(confirmId);
    if (elm == null) {
        elm = document.createElement('div');
        elm.id = confirmId;
        document.body.appendChild(elm);
    }
    const root = createRoot(elm);
    root.render(
        <ConfirmModal
            title={texts.title}
            body={
                'body' in texts ? (
                    texts.body
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: texts.bodyHTML }} />
                )
            }
            cancelText={texts.cancel}
            confirmText={texts.confirm}
            onCancel={() => root.unmount()}
            onConfirm={() => {
                (event.target as HTMLFormElement).submit();
            }}
            class="px-[75px] py-30"
        />,
    );
}
